import { defineMessages } from 'react-intl';

const scope = 'app.knowledge.KnowledgeMapWarningPopover';

export default defineMessages({
  warningTitle: {
    id: `${scope}.warningTitle`,
    defaultMessage: 'The level of objectives in your map is inconsistent',
  },
  warningMessage: {
    id: `${scope}.warningMessage`,
    defaultMessage: 'Knowledge Maps should either have no Enabling Objectives or every Learning Objective should have at least two Enabling Objectives.',
  },
});
